export default __webpack_public_path__ + "static/media/python.b2fd575c.jpg";